import React from "react";
import { RiskAnalysisCard } from "Modules/riskAnalysisCard";
import { Version } from "Types";
import { useVersionReportSummary } from "../../hooks";
import ChecksCard from "./ChecksCard/ChecksCard";
import styles from "./releasesList.module.scss";

type VersionDetailsProps = {
  rowIndex: number;
  version: Version;
  predecessor: Version | undefined;
  attachedToExternalCatalog: boolean;
  predecessorDeleted: boolean;
};

const VersionDetails = ({
  rowIndex,
  version,
  predecessor,
  attachedToExternalCatalog,
  predecessorDeleted,
}: VersionDetailsProps): React.JSX.Element => {
  const { reportSummary, reproAnalysisDone, showReproReport, toggleReport } =
    useVersionReportSummary(version);
  const {
    reportSummary: predecessorReportSummary,
    reproIsFinal: predecessorReproIsFinal,
  } = useVersionReportSummary(predecessor);

  return (
    <div className={styles["expanded-row-details"]}>
      {reportSummary && (
        <RiskAnalysisCard
          id={`current-${rowIndex}`}
          file={{
            type: "VERSION",
            displayName: `${version.software_info.product} ${version.software_info.version}`,
            fileName: version.file_name,
            imported_from: version.imported_from,
            id: version.version_id,
            software_info: version.software_info,
            latest_report_summary: reportSummary,
          }}
          referenceFile={
            predecessor && predecessorReportSummary
              ? {
                  type: "VERSION",
                  displayName: `${predecessor.software_info.product} ${predecessor.software_info.version}`,
                  fileName: predecessor.file_name,
                  imported_from: predecessor.imported_from,
                  id: predecessor.version_id,
                  software_info: predecessor.software_info,
                  latest_report_summary: predecessorReportSummary,
                  deleted: predecessorDeleted,
                }
              : undefined
          }
          reportDetails={{
            projectName: version.project_name,
            packageName: version.package_name,
            version: version.software_info.version,
            isRepro: showReproReport ?? false,
          }}
          referenceReportDetails={
            predecessor && predecessorReportSummary
              ? {
                  projectName: predecessor.project_name,
                  packageName: predecessor.package_name,
                  version: predecessor.software_info.version,
                  isRepro: predecessorReproIsFinal,
                }
              : undefined
          }
          showViewReportButton={false}
          showEditButton={!attachedToExternalCatalog}
          showReproReport={reproAnalysisDone ? showReproReport : undefined}
          onCardToggle={reproAnalysisDone ? toggleReport : undefined}
        />
      )}
      <ChecksCard version={version} className={styles["checks-card"]} />
    </div>
  );
};

export default VersionDetails;
